/**
 * Order Details
 */

// React
import React, {useState, useEffect, useContext} from 'react';

// Context
import AuthContext from '../../../authContext';

// Redux
import {connect} from 'react-redux';
import {compose} from 'redux';
import {Store} from '../../../redux/reducers';
import {
  clearOrderAction,
  getAllOrderItemsAction,
  getOrderWithIdAction,
  updateOrderStatusActions,
  getLogsAction,
} from '../../orders/actions';

// Selector
import {createStructuredSelector} from 'reselect';
import {
  makeSelectOrder,
  makeSelectLoading,
  makeSelectError,
  makeSelectAllOrderItems,
  makeSelectLogs,
} from '../../orders/selectors';

//UI
import theme from '../../../theme';
import {
  Typography,
  Paper,
  Grid,
  CircularProgress,
  Radio,
  RadioGroup,
  Select,
  FormControl,
  FormControlLabel,
  Card,
  CardHeader,
  CardContent,
  Tab,
  Tabs,
  Box,
} from '@material-ui/core';

import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
} from '@material-ui/lab';

// Components
import ListOrderItems from './list';
import Can from '../../../components/Can';

// Rules
import {
  rulesAdminChangeOrderStatus,
  rulesOrderStatus,
} from '../../../utils/rulesOrderStatus';

// Helper
import {translate, formaterPhoneNumber} from '../../../utils/helpers';
import jMoment from 'moment-jalaali';

// Type

import {Status, Log} from '../../orders/interfaces';
import {SelectorProps, Props} from '../interfaces';
import {getInventoryItemsWithSerialAction} from '../../parcels/actions';
import {makeSelectInventoryItemsWithSerialList} from '../../parcels/selectors';
import classes from '../index.module.scss';
import {Link} from 'react-router-dom';
import RonadIcons from '../../../components/iconComponent';
import handleError from '../../../utils/handleError';
import ordersRepository from 'client-sdk/src/Repository/orders-repository';

const colorStatus = {
  ARRIVED: theme.palette.green.main, //'به مقصد رسیده',
  BUNDLED: theme.palette.green.main, //' بسته‌بندی شده برای راننده',
  CANCELLED: theme.palette.error.main, //'لغو شده',
  DELIVERED_TO_POST: theme.palette.green.main, //'ارسال شده',
  DELIVERED_TO_CENTER: theme.palette.green.main, //'تحویل در مرکز',
  SUPPLIED_IN_CENTER: theme.palette.green.main, //'تامین در مرکز',
  PACKAGED: theme.palette.green.main, //'بسته‌بندی شده برای مشتری',
  DELIVERED: theme.palette.green.main, //'تحویل داده شده',
  LOADED: theme.palette.green.main, // 'در حال تحویل',
  NOT_DELIVERED: theme.palette.orange.main, //'تحویل داده نشده',
  ORDERED: theme.palette.green.main, //'ایجاد شده',
  RETURNED: theme.palette.neutral.main, //'بازگردانده شده',
  PICKED: theme.palette.orange.main, //'بازگردانده شده',
  ASSIGNED: theme.palette.blue.main, //'بازگردانده شده',
};

const iconStatus = {
  ARRIVED: "mapMarker", //'به مقصد رسیده',
  BUNDLED: "packageVariantClosed", //' بسته‌بندی شده برای راننده',
  CANCELLED: "times", //'لغو شده',
  DELIVERED_TO_POST: "circleMedium", //'ارسال شده',
  DELIVERED_TO_CENTER: "circleMedium", //'تحویل در مرکز',
  SUPPLIED_IN_CENTER: "circleMedium", //'تامین در مرکز',
  PACKAGED: "cubeOutline", //'بسته‌بندی شده برای مشتری',
  DELIVERED: "listCheck", //'تحویل داده شده',
  LOADED: "truck", // 'در حال تحویل',
  NOT_DELIVERED: "information", //'تحویل داده نشده',
  ORDERED: "circleMedium", //'ایجاد شده',
  RETURNED: "undo", //'بازگردانده شده',
  PICKED: "plusMultiple", //'برداشته شده',
  ASSIGNED: "userArrowRight", //'برداشته شده',
  DELIVERING_TO_POST: 'circleMedium',
  DELIVERED_TO_COURIER: 'circleMedium',
  PROCESSING: 'circleMedium',
  PROCESSED: 'circleMedium',
  REGISTERED_IN_3PL: 'circleMedium',
  REGISTERING_IN_3PL: 'circleMedium',
  DELIVERING: 'circleMedium',
  DELIVERED_TO_3PL: 'circleMedium',
  DELIVERED_TO_3PL_COURIER: 'circleMedium',
  CANCELED_FROM_3PL: 'circleMedium',
  AWAITING_REVIEW: 'circleMedium',
  SUPPLYING: 'circleMedium',
  REQUESTED_TO_RETURN: 'circleMedium',
  RETURNED_TO_WAREHOUSE: 'circleMedium',
  REQUESTED_TO_RESEND: 'circleMedium',
  SCANNED: 'circleMedium',
  CONFIRMED: 'circleMedium',
  REGISTERED: 'circleMedium',
  AWAITING_PAYMENT: 'circleMedium',
  CANCELED: 'times',
};

export function DetailsMobile(props: Props) {
  const authContext = useContext(AuthContext);
  const [value, setValue] = useState(0);
  const [isTapin, setIsTapin] = useState<boolean>(false);
  const [tapinBarcode, setTapinBarcode] = useState<number | undefined>();
  
  const getTapinBarcode = async id => {
    try {
      const response = await ordersRepository.getOrderTapinBarcode({
        payload: {
          ids: id,
        },
      });
      const myResponse = response.data.barcodes[0]?.barcode[0];
      setTapinBarcode(myResponse);
      setIsTapin(true);
    } catch (error) {
      handleError(error);
    }
  };
  useEffect(() => {
    // console.log('From useEffect: ', tapinBarcode, isTapin);
  }, [tapinBarcode, isTapin]);


  useEffect(() => {
    const {id} = props.match.params;
    getTapinBarcode(id);
    props.orderWithIdActionDispatch(id);
    props.getOrderItemsActionDispatch({
      'orderId.equals': id,
      page: 0,
      size: 1000,
    });
  }, []);

  useEffect(() => {
    props.getLogsDispatch(props.match.params.id);
  }, [props.order]);

  useEffect(() => {
    return () => {
      props.clearOrderActionDispatch();
    };
  }, []);

  const handleShowInventoryItems = (data: any) => {
    props.getInventoryItems({
      orderItemId: {equals: data.id},
    });
  };

  const handleOpenConfirmUpdateState = (body: Status) => {};
  const a11yProps = (index: number) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  };
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const TabPanel = (props: any) => {
    const {children, value, index, ...other} = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box>{children}</Box>}
      </div>
    );
  };
  return (
    <div className={classes.root}>
      <Box className={classes.tabs}>
        <Tabs
          value={value}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleChange}
          aria-label="basic tabs example"
          variant="fullWidth"
        >
          <Tab label="اطلاعات سفارش" {...a11yProps(0)} />
          <Tab label="لیست کالاها" {...a11yProps(1)} />
          <Tab label="تاریخچه" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <Grid
        className={classes.topBox}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Paper
          elevation={0}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '83%',
            borderRadius: '0',
            padding: '0 10px',
          }}
        >
          <div className={classes.headerBox}>
            <Typography variant="h6" component="h2">
              جزيیات سفارش
              <span data-cy="orderIdHead"> &nbsp; {props.order.id}</span>
            </Typography>
          </div>
          <Link to={`/edit-order/${props.order.id}`}>
            <button
              aria-label="edit"
              size="small"
              title="ویرایش"
              data-cy="edit"
              className={classes.editBtn}
            >
              <RonadIcons name='pencil' />
            </button>
          </Link>
        </Paper>
      </Grid>

      <Grid
        container
        lg={12}
        md={12}
        style={{marginBottom: '32px', marginTop: '55px'}}
      >
        <TabPanel value={value} index={0}>
          {props.order?.deliveryType !== 'COURIER' && (
            <Card className={classes.card}>
              <CardHeader
                avatar={
                  <Typography className={classes.typographyCards}>
                    مشخصات مرسوله پستی
                  </Typography>
                }
              />
              <CardContent style={{paddingBottom: '10px'}}>
                <Grid xs={12} sm={12} lg={12} spacing={2}>
                {isTapin === true && (
                          <Grid item xs={12} sm={12}>
                            <div className={classes.item}>
                              <span className={classes.label}>
                                {'کد رهگیری پست:  '}
                              </span>
                              <span data-cy={'barcode' + index}>
                                {order.barcode}
                              </span>
                            </div>
                          </Grid>
                        )}

                  {props.order?.postOrders?.map((order, index) => {
                    return (
                      <>
                        <Grid item xs={12} sm={12}>
                          <div className={classes.item}>
                            <span style={{fontSize: '18px'}}>
                              بسته {index + 1}
                            </span>
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <div className={classes.item}>
                            <span className={classes.label}>
                              {'وضعیت مرسوله:  '}
                            </span>
                            <span data-cy={'orderStatus' + index}>
                              {translate(order.orderStatus, 'order')}
                            </span>
                          </div>
                        </Grid>
                        {order.barcode && (
                          <Grid item xs={12} sm={12}>
                            <div className={classes.item}>
                              <span className={classes.label}>
                                {'کد رهگیری پست:  '}
                              </span>
                              <span data-cy={'barcode' + index}>
                                {order.barcode}
                              </span>
                            </div>
                          </Grid>
                        )}
                        {order.weight && (
                          <Grid item xs={12} sm={12}>
                            <div className={classes.item}>
                              <span className={classes.label}>
                                {'وزن پستی (گرم):  '}
                              </span>
                              <span data-cy={'orderWeight' + index}>
                                {order.weight}
                              </span>
                            </div>
                          </Grid>
                        )}
                        {order.totalPrice && (
                          <Grid item xs={12} sm={12}>
                            <div className={classes.item}>
                              <span className={classes.label}>
                                {'هزینه پست (ریال):  '}
                              </span>
                              <span data-cy="totalPrice">
                                {order.totalPrice}
                              </span>
                            </div>
                          </Grid>
                        )}
                      </>
                    );
                  })}
                </Grid>
              </CardContent>
            </Card>
          )}
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  اطلاعات سفارش
                </Typography>
              }
            />
            <CardContent style={{paddingBottom: '10px'}}>
              <Grid item xs={12} sm={12} lg={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'وضعیت تحویل:  '}</span>
                  <Can
                    role={authContext.user.role}
                    perform="orders:changeOrderStatus"
                    yes={() => (
                      <FormControl style={{width: '50%'}}>
                        <RonadIcons name='pencil' className={classes.changStatusIcon}/>
                        <Select
                          className={classes.changStatusBox}
                          fullWidth
                          inputProps={{
                            name: 'name',
                            id: 'uncontrolled-native',
                          }}
                          name={'status'}
                          id={props.order.rubikaId}
                          value={[{}]}
                          IconComponent={() => null}
                          renderValue={() => (
                            <span className={classes.renderValue}>
                              {translate(props.order.status, 'order')}
                            </span>
                          )}
                        >
                          <RadioGroup
                            className={classes.radioGroup}
                            aria-label={'status'}
                            name={'status$'}
                            value={'item'}
                            onChange={(
                              e: React.ChangeEvent<{value: unknown}>
                            ) =>
                              handleOpenConfirmUpdateState(
                                `"${e.target.value}"` as Status
                              )
                            }
                          >
                            {rulesOrderStatus[props.order.status]?.map(
                              (item: any, index: number) => (
                                <FormControlLabel
                                  className={classes.radioGroupItem}
                                  key={index}
                                  checked={props.order.status === item}
                                  value={item}
                                  disabled={
                                    rulesAdminChangeOrderStatus[
                                      authContext.user.role
                                    ].indexOf(item) === -1
                                  }
                                  control={<Radio />}
                                  label={translate(item, 'order')}
                                />
                              )
                            )}
                          </RadioGroup>
                        </Select>
                      </FormControl>
                    )}
                    no={() => (
                      <span style={{textAlign: 'left'}} data-cy="status">
                        {translate(props.order.status, 'order')}
                      </span>
                    )}
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={12} lg={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'شیوه پرداخت :  '}</span>

                  <span>{props.order.paymentType}</span>
                </div>
              </Grid>
              {props.order?.paymentType === 'COD' && (
                <Grid item xs={12} sm={12} lg={12} spacing={2}>
                  <div className={classes.item}>
                    <span className={classes.label}>{'مبلغ فاکتور:  '}</span>

                    <span>{props.order.codValue}</span>
                  </div>
                </Grid>
              )}
              <Grid item xs={12} sm={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'کدپیگیری:  '}</span>
                  <span data-cy="trackingCode">
                    {props.order?.trackingCode}
                  </span>
                </div>
              </Grid>
                            <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'نوع ارسال:  '}</span>
                  <span data-cy="deliveryType">
                    {translate(props.order?.deliveryType)}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{' تاریخ ثبت سفارش:  '}</span>
                  <span data-cy="registrationDate">
                    {props.order.registrationDate &&
                      `${jMoment(props.order.registrationDate, 'YYYY/MM/DD')
                        .locale('fa')
                        .format('jYYYY/jMM/jDD')}`}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {'تاریخ تحویل سفارش:  '}
                  </span>
                  <span data-cy="deliveryDate">
                    {props.order.deliveryDate &&
                      `${jMoment(props.order.deliveryDate, 'YYYY/MM/DD')
                        .locale('fa')
                        .format('jYYYY/jMM/jDD')}`}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {' بازه تحویل سفارش:  '}
                  </span>
                  <span data-cy="deliveryStartTime">
                    {props.order.deliveryStartTime &&
                      jMoment(props.order.deliveryStartTime, 'hh:mm:ss')
                        .locale('fa')
                        .format('HH:mm')}
                    {' - '}
                    {props.order.deliveryEndTime &&
                      jMoment(props.order.deliveryEndTime, 'hh:mm:ss')
                        .locale('fa')
                        .format('HH:mm')}
                  </span>
                </div>
              </Grid>
              {props.order.description && (
                <Grid item xs={12} sm={12}>
                  <div className={classes.item}>
                    <span className={classes.label}>{'توضیحات:  '}</span>
                    <span data-cy="description">
                      {props.order.description && props.order.description}
                    </span>
                  </div>
                </Grid>
              )}
            </CardContent>
          </Card>
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  اطلاعات سفارش‌دهنده
                </Typography>
              }
            />
            <CardContent style={{paddingBottom: '10px'}}>
              <Grid xs={12} sm={12} lg={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'نام:   '}</span>

                  <span data-cy="customerName">{props.order.customerName}</span>
                </div>
              </Grid>
              <Can
                role={authContext.user.role}
                perform="orders-info:more-info"
                yes={() => (
                  <>
                    <Grid item xs={12} sm={12}>
                      <div className={classes.item}>
                        <span className={classes.label}>{'کد ملی:'}</span>
                        <span data-cy="customerNationalCode">
                          {props.order?.customerNationalCode}
                        </span>
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={12}>
                      <div className={classes.item}>
                        <span className={classes.label}>
                          {' شماره ثابت:     '}
                        </span>
                        <span dir="ltr" data-cy="customerPhoneNumber">
                          {props.order?.customerPhoneNumber}
                        </span>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <div className={classes.item}>
                        <span className={classes.label}>
                          {'شماره همراه:  '}
                        </span>
                        <span data-cy="customerMobileNumber">
                          {formaterPhoneNumber(
                            props.order.customerMobileNumber
                          )}
                        </span>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <div className={classes.item}>
                        <span className={classes.label}>{' کد پستی:    '}</span>
                        <span data-cy="customerZipCode">
                          {props.order?.customerZipCode}
                        </span>
                      </div>
                    </Grid>
                  </>
                )}
              />
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'شهر:  '}</span>

                  <span data-cy="customerCity">
                    {props.order?.customerCity}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'استان:  '}</span>

                  <span data-cy="customerProvince">
                    {props.order?.customerProvince}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.item}>
                  <span className={classes.label} style={{alignSelf: 'start'}}>
                    {'آدرس:  '}
                  </span>
                  <span
                    style={{textAlign: 'left', marginRight: '30px'}}
                    data-cy="customerAddress"
                  >
                    {props.order.customerAddress && props.order.customerAddress}
                  </span>
                </div>
              </Grid>
            </CardContent>
          </Card>
        </TabPanel>
        <TabPanel value={value} index={1} style={{width: '100%'}}>
          <Card className={classes.cardM}>
            <CardContent
              style={{padding: '0'}}
              className={classes.cardContentList}
            >
              <Grid item xs={12}>
                {props.loading ? (
                  <div className={classes.loading}>
                    <CircularProgress />
                  </div>
                ) : (
                  props.order?.items && (
                    <>
                      <ListOrderItems
                        data={props.orderItems}
                        showItems={data => handleShowInventoryItems(data)}
                      />
                    </>
                  )
                )}
              </Grid>
            </CardContent>
          </Card>
        </TabPanel>
        <TabPanel value={value} index={2} style={{width: '100%'}}>
          <Card className={classes.card}>
            <CardContent style={{padding: '0', marginTop: '-10px'}}>
              <Grid container style={{padding: '0'}}>
                <Grid item xs={12}>
                  <Timeline align="left">
                    {props.logs
                      ?.slice()
                      .reverse()
                      .map((log: Log, index: number) => (
                        <TimelineItem
                          className={classes.missingOppositeContent}
                          key={index}
                          data-cy="timeLineItem"
                        >
                          <TimelineSeparator>
                            <TimelineDot
                              style={{
                                backgroundColor: colorStatus[log.newStatus],
                                border: index === 0 ? 'solid 4px #DF9234' : '',
                              }}
                            >
                              <RonadIcons name={iconStatus[log.newStatus]} size={1} className='text-white'/>
                            </TimelineDot>
                            {index !== props.logs?.length - 1 ? (
                              <TimelineConnector />
                            ) : (
                              ''
                            )}
                          </TimelineSeparator>
                          <TimelineContent className={classes.paperHistory}>
                            <div style={{padding: '10px'}}>
                              <div className={classes.contentBox}>
                                <div style={{flex: 2, textAlign: 'right'}}>
                                  <span data-cy="status">
                                    {translate(log.newStatus, 'order')}
                                  </span>
                                  <br />
                                  <Can
                                    role={authContext.user.role}
                                    perform="user-name:dontShowInLogs"
                                    no={() => (
                                      <>
                                        <span>{log.modifierName}</span>
                                        <span>
                                          {' '}
                                          &nbsp; &nbsp;- &nbsp; &nbsp;
                                        </span>
                                      </>
                                    )}
                                  />
                                  <span data-cy="role">
                                    {translate(log.modifierRole, 'user')}
                                  </span>
                                  <Typography
                                    component="div"
                                    className={classes.titleBox}
                                    style={{flex: 1}}
                                  >
                                    {log.time &&
                                      jMoment(
                                        log.time,
                                        'YYYY/MM/DDTHH:mm:ss.SSZ'
                                      )
                                        .locale('fa')
                                        .format('jYYYY/jMM/jDD - HH:mm')}
                                  </Typography>
                                </div>
                              </div>
                            </div>
                          </TimelineContent>
                        </TimelineItem>
                      ))}
                  </Timeline>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </TabPanel>
      </Grid>
    </div>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  logs: makeSelectLogs(),

  order: makeSelectOrder(),
  orderItems: makeSelectAllOrderItems(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
  inventoryItems: makeSelectInventoryItemsWithSerialList(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getLogsDispatch: (id: number) => dispatch(getLogsAction({id})),
    orderWithIdActionDispatch: (id: number) =>
      dispatch(getOrderWithIdAction({id})),
    orderWithIdActionDispatch: (id: number) =>
      dispatch(getOrderWithIdAction({id})),
    updateOrderStatusDispatch: (payload: {
      id: number;
      body: string;
      pagination: object;
      callback?: () => void;
    }) => dispatch(updateOrderStatusActions(payload)),
    clearOrderActionDispatch: () => dispatch(clearOrderAction()),
    getInventoryItems: (payload: Record<string, any>) =>
      dispatch(getInventoryItemsWithSerialAction(payload)),
    getOrderItemsActionDispatch: (payload: any) =>
      dispatch(getAllOrderItemsAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(DetailsMobile);
